import { CommonRegex } from './CommonRegex.js';
import { logger } from './Debug.js';

const parseIsoDateTime = (dateTimeString) => {
    if (!dateTimeString) {
        return undefined;
    }
    if (!dateTimeString.match(CommonRegex.dateTimeStringRegex)) {
        logger.error('[DateUtils][parseIsoDateTime]: dateTimeString is not match regex or does not exist parsing', dateTimeString);
        return undefined;
    }
    return new Date(dateTimeString);
};

export { parseIsoDateTime };
